import { createIcon } from '@chakra-ui/react';

export const ExclamationMark = createIcon({
  displayName: 'ExclamationMark',
  viewBox: '0 0 20 20',
  path: (
    <>
      <rect
        id="bg"
        width="20"
        height="20"
        transform="translate(0 0)"
        fill="#fff"
      />
      <path
        id="Warning_Circle_-_L-2"
        data-name="Warning Circle - L"
        d="M9.712,12.516h1.562a.349.349,0,0,0,.349-.333l.317-6.873a.349.349,0,0,0-.349-.365h-2.2a.349.349,0,0,0-.349.365l.317,6.873a.349.349,0,0,0,.349.333Zm.781.613a1.46,1.46,0,1,0,1.036.428,1.463,1.463,0,0,0-1.036-.428ZM10.493.5a10,10,0,1,0,10,10,10,10,0,0,0-10-10Zm0,19.063a9.063,9.063,0,1,1,9.06-9.062,9.063,9.063,0,0,1-9.06,9.062Z"
        transform="translate(-0.49 -0.5)"
        fill="currentColor"
      />
    </>
  ),
});
